<template>
    <div class="block-products-carousel__column" style="min-height: 350px">  
        <div class="block-products-carousel__cell">
            <div class="product-card product-card--layout--grid">
                
                <div class="product-card__image">                          
                    <div class="image image--type--product"> 
                        <!-- <a :href="productDetails.product_url" class="image__body"> -->
                        <router-link :to="routeTo(productDetails.ID)" class="image__body">
                            <img class="image__tag" :src="productDetails.image" alt="">
                        </router-link> 
                    </div>                                                   
                </div>                        
                <div class="product-card__info">                                                  
                    <div class="product-card__name">                            
                        <div>
                            <div class="product-card__badges">
                                <!-- <span v-html="button"> </span> -->
                                <!-- v-if="productDetails.is_sale"-->
                                <div class="tag-badge" v-if="promo_text != ''">
                                    <span :style="'background:' + promo_color + ';color: rgb(255, 255, 255);padding: 4px 14px 4px;height: 18px;font-size: 13px;font-weight: 800;'">{{promo_text}}</span>
                                </div>
                                <!--  v-if="productDetails.is_new" -->
                                <!-- <div class="tag-badge tag-badge--new">new</div>
                                <div class="tag-badge tag-badge--hot">hot</div> -->
                            </div>
                            <router-link :to="routeTo()" >
                                {{productDetails.feat_name}} - {{productDetails.IMITMC}}
                            </router-link> 
                        </div>                          
                    </div>                       
                    <div class="product-card__footer">                          
                        <div class="product-card__prices">                            
                            <div class="product-card__price product-card__price--current notranslate">{{toUSD(productDetails.yourprice)}}</div>                          
                        </div>					
                        <div class="qty-selector-carousel-home">
                            <base-quantity-input v-model="quantity" @changedQty="changedQty"></base-quantity-input>
                        </div>	                           
                        <button class="product-card__addtocart-icon" type="button" aria-label="Add to cart" @click="AddToCart()">
                            <svg width="20" height="20">                              
                                <circle cx="7" cy="17" r="2" />                              
                                <circle cx="15" cy="17" r="2" />                              
                                <path d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6 	V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4 	C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z" />                            
                            </svg>                        
                        </button>                        
                    </div>
                </div>                    
            </div>
        </div>    
    </div> 

</template>
<script>
import Price from '../../../mixins/price.js';

export default {
    props: {
        // index : {
        //     type: Number,
        //     required: true,
        // },
        productDetails: {
            type: Object,
            required: true
        }
    },

    mixins: [ Price ],
    data() {
        return {
            quantity : 1,
            max_stars: 5
        };
    },

    computed: {
        button() {
            if(this.productDetails.metadata['slider-1-button'] != undefined){
                return this.productDetails.metadata['slider-1-button'];
            }else{
                return '';
            }
        },

        promo_text() {
            if(this.productDetails.metadata['promotion_text'] != undefined){
                return this.productDetails.metadata['promotion_text'];
            }else{
                return '';
            }
        },


        promo_color() {
            if(this.productDetails.metadata['promotion_color'] != undefined){
                return this.productDetails.metadata['promotion_color'];
            }else{
                return '';
            }
        }
    },

    methods: {
        AddToCart() {
            // const linetotal = 1 * fields.EIEXCP.value;

            this.$store.dispatch("cart/addToCart", {
                ID : this.productDetails.ID,
                item: this.productDetails.ID,
                desc: this.productDetails.name,
                manufacturer: this.productDetails.manufacturer,
                image: this.productDetails.image,
                quantity: this.quantity,

                mfgSeo: this.productDetails.mfgSeo,
                itemSeo: this.productDetails.itemSeo,

                listprice: this.productDetails.listprice,
                old_price: this.productDetails.old_price,
                corecharge: this.productDetails.corecharge,
                yourprice: this.productDetails.yourprice,

                // new fields
                XRMFGC: this.productDetails.XRMFGC,
                XRITMC: this.productDetails.XRITMC,
                IMIGSA: this.productDetails.IMIGSA,
                IMISVALID: this.productDetails.IMISVALID,
            });
        },

        changedQty() {
            
        },

        routeTo() {
            const clearProductCode = encodeURIComponent(this.productDetails.IMITMC);
            return '/part/' + this.productDetails.manufacturer + '/'+ clearProductCode + '/' + this.productDetails.mfgSeo + '/'+ this.productDetails.itemSeo;
        }
    },

    created() {
        // console.log(this.productDetails);
        // https://demo.qwik-orderplus.com/sub-category/C1500
    }
}
</script>